import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { SupportStats } from "types/SupportAgent";
import { handleRequestError } from "utils/Request";

async function fetchSupportStats(categoryId: string): Promise<SupportStats> {
  const { data } = await api.get('/support/agents/stats', { params: { category_id: categoryId } });
  return data;
}

export function useSupportStats(categoryId: string) {
  const query = useQuery(['support-stats', categoryId], () => fetchSupportStats(categoryId), {
    enabled: !!categoryId,
  });

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Erro ao carregar estatísticas de distribuição.');
  }, [query.isError, query.error]);

  return query;
}
